import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { sanitizeInnerHtml } from 'ctm-util-functions';

const InnerFlexBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => props.isXs ? 'center' : 'space-between' };
    margin: ${(props) => props.isXs ? '0 2.4rem' : '0 11rem 0 0' };
    align-items: ${(props) => props.isXs ? 'center' : 'flex-start'};
    text-align: ${(props) => props.isXs ? 'center' : 'justify'};
    height: 100%;
`;

const SubHeading = styled.div`
    color: white;
    font-weight: ${(props) => props.isXs ? '500' : '700'};
    line-height: ${(props) => props.isXs ? '135%' : '170%' };
    font-size: ${(props) => props.isXs ? '16px' : '18px' };
    font-style: normal;
`;

const Line = styled.div`
    margin-top: 10px;
    margin-bottom: 10px;
    width: 34px;
    height: 2px;
    background-color: #F5D155;
    margin-left: 0;
    border-radius: 1px 1px 1px 1px;
`;

const Heading = styled.div`
    padding-bottom: 24px;
    font-weight: 500;
    font-size: ${(props) => props.isXs ? '24px' : '32px' };
    line-height: 135%;
`;

const PersonalisedText = styled.div`
    color: white;
    font-size: ${(props) => props.isXs ? '16px' : '18px'};
    font-style: normal;
    font-weight: 500;
    line-height: 170%;
    ${(props) => !props.isXs && '::first-line { word-spacing: -2px; };'}
`;

const HeaderBannerText = (props) => {
    const {
        subheadingHtml, headingHtml, personalisedTextHtml
    } = props;
    return (
        <InnerFlexBox isXs={props.isXs}>
            <SubHeading isXs={props.isXs}>
                {subheadingHtml()}
            </SubHeading>
            <Line/>
            <Heading isXs={props.isXs}>
                {headingHtml()}
            </Heading>
            <PersonalisedText isXs={props.isXs}>{personalisedTextHtml()}</PersonalisedText>
        </InnerFlexBox>
    );
};

HeaderBannerText.propTypes = {
    subheadingHtml: PropTypes.func,
    headingHtml: PropTypes.func,
    personalisedTextHtml: PropTypes.func,
    isXs: PropTypes.bool
};

export { HeaderBannerText };